import { render } from "./CashierManualView.vue?vue&type=template&id=678bb1bc"
import script from "./CashierManualView.vue?vue&type=script&lang=js"
export * from "./CashierManualView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__